import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { PublicationStatus } from 'lib-knowledge-management-common/graphql';
import { StatusBadge } from 'versionHistory/components/statusBadge';
import { Version } from 'versionHistory/hooks/useVersions';
import { formatDate } from 'versionHistory/utils';

import { AiAssistedBadge } from 'components/aiAssistedBadge';

type CurrentVersionDetailsProps = {
  publicationStatus?: PublicationStatus;
  versionMeta?: Version;
  editedAt?: number;
  editedBy?: string;
  isAiAssisted?: boolean;
};

export function CurrentVersionDetails({
  publicationStatus,
  versionMeta,
  editedAt,
  editedBy,
  isAiAssisted,
}: CurrentVersionDetailsProps): JSX.Element {
  if (publicationStatus === PublicationStatus.Published && versionMeta) {
    return (
      <div>
        <FlexBox alignItems="center" gap="100">
          <Text.Paragraph variant="1">
            <strong>Current Version</strong>
          </Text.Paragraph>
          <StatusBadge publicationStatus={publicationStatus} />
          {isAiAssisted && <AiAssistedBadge />}
        </FlexBox>
        <Text.Paragraph variant="2" subdued>
          {formatDate(versionMeta.publishedAt)}
        </Text.Paragraph>
        <Text.Paragraph variant="2" subdued>
          Published by {versionMeta.publishedBy}
        </Text.Paragraph>
      </div>
    );
  }
  if (editedAt && editedBy) {
    return (
      <div>
        {publicationStatus && (
          <FlexBox alignItems="center" gap="100">
            <Text.Paragraph variant="1">
              <strong>Current Version</strong>
            </Text.Paragraph>
            {/** Always show non-published status as draft */}
            <StatusBadge
              publicationStatus={PublicationStatus.PublishedWithDraft}
            />
            {isAiAssisted && <AiAssistedBadge />}
          </FlexBox>
        )}
        <Text.Paragraph variant="2" subdued>
          {formatDate(editedAt)}
        </Text.Paragraph>
        <Text.Paragraph variant="2" subdued>
          Last Edited by {editedBy}
        </Text.Paragraph>
      </div>
    );
  }
  return <></>;
}
